import React from 'react';
import { useTranslation } from 'react-i18next';

const useLocale = () => {
    const [locale, setLocale] = React.useState('');
    const { i18n } = useTranslation();
    const setLocaleOption = React.useCallback((locale) => {
        if (locale) {
            const formattedLocale = locale.replace('_', '-');
            setLocale(formattedLocale);
            i18n.changeLanguage(formattedLocale);
        }
    }, [i18n]);
    return {
        setLocaleOption,
        locale,
    };
};

export default useLocale;
